// extracted by mini-css-extract-plugin
var _1 = "DocFlowResultTableRow-moduleDocFlowResultTableRow__zwfvc TableComponent-modulerow__xPAo4";
export { _1 as "DocFlowResultTableRow" }
